<template>
    <div class="paypal_container">
        <PayPal
            class="fade"
            :class="canPurchase() ? 'show' : ''"
            :offer="offer"
            :client="paypalConfig.credentials"
            :env="PAYPAL_ENV"
            :button-style="paypalConfig.style"
            :locale="locale"
            @payment-authorized="paymentAuthorized"
            @payment-cancelled="paymentCancelled"
            @payment-error="paymentError"
            @button-loaded="buttonLoaded"
        >
        </PayPal>
    </div>
</template>

<script>
    import PayPal from './PayPalCheckout';
    import {mapGetters} from 'vuex';
    import paypalConfig from './paypal-config.json';
    import {PAYPAL_ENV} from '../../config/_paypal';

    export default {
        props: ['offer', 'locale'],
        components: {
            PayPal
        },
        computed: {
            ...mapGetters({
                userData: 'user/auth/userData',
                error: 'offer/show/error',
            })
        },
        data() {
            return {
                paypalConfig: paypalConfig,
                PAYPAL_ENV: PAYPAL_ENV,
                enabled: false
            }
        },
        methods: {
            paymentError(msg) {
                this.$notify.error(this.$t(msg));
            },
            paymentAuthorized(data) {
                const selectedOffer = {...this.offer};
                this.$emit('payment-authorized');
                this.$store.dispatch('offer/execute/executeTransaction', {
                    offer: selectedOffer,
                    payerId: data.payerID,
                    paymentId: data.paymentID
                }).then(() => {
                    this.$store.dispatch('app/giveAway/getGiveAwayQuestion');
                    this.$store.dispatch('offer/list/getPaidItems');
                    this.$notify.success(this.$t('offers.success'));
                }).catch((e) => {
                    this.paymentError(e.message);
                });
            },
            paymentCancelled() {
                this.paymentError('packs.payment.cancelled');
            },
            buttonLoaded() {
                this.enabled = true;
            },
            canPurchase() {
                return this.enabled && this.offer;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/marketplace/PaypalButton.vue